export const materialTranslationFr = {
    material: {
        captcha: {
            links: {
                submit: 'Vérifier',
                erase: 'Effacer',
            },
        },
        visitor: {
            home: {
                links: {
                    authentication: {
                        label: "S'identifier",
                    },
                    identifier: {
                        title: 'Sur le site',
                        label: 'Où trouver vos identifiants ?',
                        references: [
                            {
                                linkWeb: {
                                    browser: 'https://assistance.orange.fr/oid/354283',
                                },
                            },
                        ],
                    },
                    'sr-code': {
                        title: 'Sur Orange et moi',
                        label: 'Scannez le QR Code',
                        'divider-label': 'ou',
                    },
                    'version-b': {
                        title: "Vous avez l'appli Orange et moi ?",
                        description:
                            'Vous pouvez scanner ce QR Code et retrouver directement vos documents. Bien vu, non ?',
                    },
                },
            },
        },
        seo: {
            login: {
                label: "S'identifier",
                identifier: {
                    label: 'Où trouver vos identifiants ?',
                    references: [
                        {
                            linkWeb: {
                                browser: 'https://assistance.orange.fr/oid/354283',
                            },
                        },
                    ],
                },
            },
            qrCode: {
                title: "Ouvrir l'appli Orange et moi",
                description: "Scannez le QR Code pour ouvrir ou télécharger l'application Orange et moi",
            },
        },
        bottomSheet: {
            title: 'Partage wifi',
            bottomTitle: 'Fermer',
            loading: {
                text: 'On récupère la clé de sécurité WiFi...',
            },
            error: {
                title: 'Clé de sécurité WiFi indisponible',
                text: 'On vous invite à réessayer ultérieurement',
            },
            qrCode: {
                subTitle: 'Scanner ce QR code depuis l’appareil que vous souhaitez connecter à votre Livebox.',
            },
            snackbar: {
                text: 'Votre clé de sécurité wifi a été copiée',
            },
        },
    },
};
